import React, { Fragment, useEffect, useState } from "react";
import GameEndModal from "./components/GameEndModal";
import GameEngine from "./components/GameEngine";
import GameStarter from "./components/GameStarter";
import AOS from "aos";
import "aos/dist/aos.css";

export default function App() {
  const [isGameStart, setIsGameStart] = useState(false);
  const [isGameEnd, setIsGameEnd] = useState(false);

  useEffect(() => {
    AOS.init();
  });

  function handleStartBtn() {
    setIsGameStart(true);
  }
  return (
    <Fragment>
      <div id="insto-360-game-app">
        {!isGameStart && <GameStarter handleStartBtn={handleStartBtn} />}
        {isGameStart && <GameEngine setIsGameEnd={setIsGameEnd} />}
      </div>
      <GameEndModal showEndModal={isGameEnd} />
      {/* {isGameEnd && <GameEndModal />} */}
    </Fragment>
  );
}
